<template>
  <div class="ticket-processor-container">
    <div style="position: absolute; right: 16px; top: 12px">
      <simple-select
        :value="params.limit"
        :options="selectOptions"
        :labelInValue="false"
        :autoSelect="false"
        @input="changeLimit"
      ></simple-select>
    </div>

    <a-spin :spinning="loading">
      <div v-if="carouselData" style="min-height: 264px">
        <a-carousel effect="fade" dotsClass="service-busy-dot" :autoplay="true">
          <cpu-usage-top
            v-for="(item, index) in carouselData"
            :key="index"
            style="min-height: 264px"
            :top-data="item"
            :colorsFunc="getColors"
            :clickEvent="clickEvent"
          >
          </cpu-usage-top>
        </a-carousel>
      </div>
      <div v-else style="min-height: 264px; position: relative; overflow: hidden;">
        <empty-component
          description="暂无数据"
          :imgUrl="require('@/assets/images/info_empty.png')"
          :body-style="{
            height: '176px',
            marginTop: '28px'
          }"
          :description-style="{
            marginTop: '-24px'
          }"
        ></empty-component>
      </div>
    </a-spin>
  </div>
</template>

<script>
import moment from 'moment'
import SimpleSelect from '@/components/select/SimpleSelect'
import { getServiceTop } from '@/api/service'
import CpuUsageTop from '@/components/top/CpuUsageTop.vue'
import EmptyComponent from '@/components/EmptyComponent.vue'

export default {
  name: 'ServiceBusy',
  components: {
    CpuUsageTop,
    SimpleSelect,
    EmptyComponent
  },
  data () {
    return {
      loading: false,
      detail: [],
      params: {
        datetime_from: moment().subtract(7, 'day').format('YYYY-MM-DD HH:mm'),
        datetime_to: moment().format('YYYY-MM-DD HH:mm'),
        top_of: 'busyness',
        limit: 5
      },
      selectOptions: [
        { label: '前 5 条', value: 5 },
        { label: '前 10 条', value: 10 },
        { label: '前 20 条', value: 20 },
        { label: '前 30 条', value: 30 },
        { label: '前 50 条', value: 50 }
      ]
    }
  },
  computed: {
    carouselData () {
      const arr = []
      if (this.detail.length) {
        const total = this.detail.length
        for (let i = 0; i < Math.ceil(total / 5); i++) {
          arr.push(this.detail.slice(i * 5, (i + 1) * 5))
        }
        return arr
      }
      return arr
    }
  },
  created () {
    this.fetch()
  },
  methods: {
    fetch () {
      this.loading = true
      getServiceTop(this.params).then(res => {
        if (res.data) this.detail = res.data.data
        else this.detail = []
      }).finally(() => {
        setTimeout(() => {
          this.loading = false
        }, 100)
      })
    },
    getColors (v) {
      if (v >= 80) {
        return '#f65961'
      } else if (v >= 60) {
        return '#fa8c16'
      } else {
        return '#43B94D'
      }
    },
    changeLimit (v) {
      this.params.limit = v
      this.fetch()
    },
    clickEvent (e) {
      const id = e.id
      if (id) this.$router.push({ name: 'ServiceDashboardDetail', params: { id } })
    }
  }
}
</script>

<style lang="less" scoped>
.ticket-processor-container {
  :deep(.service-busy-dot) {
    li button {
      background: #9a9a9a;
      height: 4px;
    }
    li.slick-active button {
      background: #096dd9;
    }
  }
  :deep(.usage-top-container) {
    height: 34px !important;
    .name-text {
      font-weight: 500;
      font-size: 13px;
    }
    .value-container {
      font-size: 14px !important;
      color: rgba(0, 0, 0, .7) !important;
    }
    .progress-container {
      margin-top: -4px !important;
    }
  }
}
</style>
